import { Image } from '@/components/client';
import {
  MAY_DELIVERY_NOTICE_IMAGE_URL,
  shouldShowMayDeliveryNoticeImage,
} from '@/utils/deliveryNoticeImage';

export const MayDeliveryNoticeImage = () => {
  if (!shouldShowMayDeliveryNoticeImage()) return null;

  return (
    <Image
      src={MAY_DELIVERY_NOTICE_IMAGE_URL}
      alt="5월 연휴 출고 안내"
      width={850}
      height={600}
      className="w-full"
      loading="eager"
      sizes="(max-width: 768px) 100vw, 850px"
    />
  );
};
